import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI/_Legacy'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)
  .attrs({
    width: 1,
    justifyContent: 'center',
    mt: [32, 96],
  })
  .withConfig({ shouldForwardProp })`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  color: ${themeGet('colors.white')};
`
export const Content = styled(Flex).attrs({
  flexDirection: ['column', 'column', 'column', 'row'],
})``

export const Info = styled(Flex).attrs({
  p: [16, 48],
})`
  min-height: 276px;
  flex-direction: column;
  flex-grow: 1;
  align-items: flex-start;
  border-radius: 8px;
  border: solid 1px ${themeGet('colors.softPeach')};
  background-color: ${themeGet('colors.white')};

  @media screen and (max-width: ${themeGet('breakpoints.0')}) {
    min-height: unset;
  }
`

export const ImageHolder = styled(Flex)
  .attrs({
    width: [1, 1, 1, 276],
    mr: [0, 0, 0, 5],
    height: [350, 400, 400, 276],
  })
  .withConfig({ shouldForwardProp })`
  flex-shrink: 0;
  overflow: hidden;
  position: relative;
  border-radius: 8px;

  img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: top;

    @media screen and (min-width: ${themeGet('breakpoints.2')}) {
      object-fit: cover;
    }
  }
`
